import React from 'react';

import { useFormContext } from 'react-hook-form';

import { DateRangeFilter } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter';
import { TabOptions } from 'components/common/CustomFilters/DateRangeFilter/DateRangeFilter.utils';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import { getInputValue } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.utils';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const FinishDate = ({ onFiltersChanged }) => {
    const { watch } = useFormContext<IFields>();

    const handleFinishDateSelection = (data: { value?: string[] | string; type?: TabOptions }) => {
        if (data.type === 'FIXED_DATE') {
            const tempFlags = watch('flags');
            delete tempFlags.endDatesRange;
            onFiltersChanged({
                finishDate: { value: Array.isArray(data.value) ? data.value.map(String) : [], type: data.type },
                flags: tempFlags,
            });
        } else {
            onFiltersChanged({
                finishDate: { value: [], type: data.type },
                flags: {
                    ...watch('flags'),
                    endDatesRange: data.value as string,
                },
            });
        }
    };

    const endDateExistingData = {
        type: watch('finishDate').type,
        value: watch('finishDate').value.length === 0 ? watch('flags').endDatesRange : watch('finishDate').value,
    };

    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Finish Date</span>
            <DateRangeFilter
                onChange={handleFinishDateSelection}
                value={endDateExistingData}
                inputDefaultValue={getInputValue(endDateExistingData)}
            />
        </div>
    );
};
